module.exports = __webpack_public_path__ + "static/media/chiropracteur.fd19f105.jpg";